import React from "react";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const { LazyLoadImage } = require("react-lazy-load-image-component");

import grayLogo from "./ms-logo-color-gray.png";

import whiteLogo from "./ms-logo-color-white.png";

 import SparkleIcon from "./SparkleIcon.png";

interface IMicrosoftLogoProps {
  color: string;
}

const MicrosoftLogo = (props: IMicrosoftLogoProps): JSX.Element => {
  const logos: { [key: string]: string } = {
    gray: grayLogo,
    white: whiteLogo,
    sparkle: SparkleIcon
  };
  const logo = props.color in logos ? logos[props.color as string] : logos.gray;

  const isSparkle = props.color === "sparkle";

  return (
    <LazyLoadImage
      height="20px"
      alt="Microsoft Logo"
      src={logo} // use normal <img> attributes as props
      width="calc(20px * 4.7)"
      style={isSparkle ? { width: "100%", height: "100%", objectFit: "contain" } : undefined}
    />
  );
};

export default MicrosoftLogo;
